






































































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  data: () => ({
    menuDate: false,
    showForm: false,
    menuPeriod: false,
    openDialog: false,
    date: '',
    period: '',
    formatoFecha: 'DD/MM/YYYY',
    formatPeriod: 'MM/YYYY',
    tipoDeComprobante: [{name: 'INGRESO'}, {name: 'EGRESO'}],
    series: [],
    documento: {
      titulo: '',
      descripcion: '',
      archivoCSV: null,
      texto: '',
      tipoDeComprobante: '',
      serie: '',
      fechaDeEmision: '',
      periodo: '',
    },
  }),
  methods: {
    async sendFile() {
      try {
        this.loading = true;
        const adm = this.$store.getters.getAdmin;
        const cond = this.$store.getters.getCondo;
        this.documento.fechaDeEmision = this.$moment(this.date).format();
        this.documento.periodo = this.$moment(this.date).format();
        const req = this.documento;
        console.log('SendFile datos: %o', req);
        const response = await this.$store.dispatch('sendFile', {adm, cond, req});
        this.openDialog = false;
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
    },
    async loadData() {
      this.loading = true;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const datos = {admin, condo};

      const series = this.$store.dispatch('getSeriesList', datos)
        .then((response) => {console.log('getSeriesList response: %o', response);
                             this.series = response; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });
    },
    async getFile() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const response = this.$store.dispatch('getFile', {adm: admin, cond: condo}).then((res) => {
        console.log('response', res);
        const blob = new Blob([res.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const filename = 'recibos.csv';
        this.downloadFromTempUrl(url, filename);
      });
    },
    downloadFromTempUrl(url, filename) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none;');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    close() {
      this.openDialog = false;
      this.showForm = false;
    },
    getCondoInfo() {
      const condo = this.$store.getters.getCondo;
      if (typeof(condo.nombre) === 'string' && condo.nombre.length > 0) {
        return condo.nombre;
      }
      return '';
    },
  },
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
    computedPeriodFormatted() {
      return this.$moment(this.period).format(this.formatPeriod);
    },
  },
  watch: {
    openDialog() {
      this.loadData();
      this.date = this.$moment().format();
      this.period = this.date;
    },
  },
});
